import { APIRoute } from '@/modules/utils'
import { Conversation } from '@/dataV3/Conversation/Conversation'
import { IRI } from 'emt-library'

export const Route = (path: IRI): APIRoute => ({
  method: 'POST',
  path,
})

export type Body = {
  content: string
}

export type Response = Conversation
